import React from 'react'
import * as S from './styled'
import type { FieldsetItemProps } from './types'

export const FieldsetItem = ({
  variant = 'medium',
  flex = 1,
  footerContent,
  alignRight,
  alignCenter,
  children,
}: FieldsetItemProps) => {
  return (
    <S.Container
      $variant={variant}
      $flex={flex}
      $alignRight={alignRight}
      $alignCenter={alignCenter}
    >
      <div>{children}</div>
      {footerContent && <S.Footer>{footerContent}</S.Footer>}
    </S.Container>
  )
}
